import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from 'react';
export const HeatmapOverlay = React.memo(function HeatmapOverlay({ visible, fileId, left, width }) {
    // No fileId → nothing to fetch, don't render at all
    if (fileId == null)
        return null;
    // Keep the last URL in a ref so the image stays visible during the
    // CSS collapse transition.  Only update when toggled ON (fresh
    // cache-bust timestamp).
    const lastUrlRef = useRef('');
    if (visible) {
        lastUrlRef.current = `url('heatmap?ts=${Date.now()}&file=${fileId}&user=-1')`;
    }
    const style = lastUrlRef.current
        ? { backgroundImage: lastUrlRef.current }
        : {};
    // Apply seek bar alignment when dimensions are provided
    if (left != null)
        style.left = left;
    if (width != null)
        style.width = width;
    const className = `hekate-player-heatmap-overlay${visible ? ' hekate-player-heatmap-overlay--visible' : ''}`;
    return (_jsx("div", { className: className, style: style, "aria-hidden": "true" }));
});
